import React, { useContext } from 'react'
import { Space, Button, Modal, message as $message } from 'antd'
import ExclamationCircleOutlined from '@ant-design/icons/ExclamationCircleOutlined'

import { Context } from '../../index'

export default () => {
    const { create, selected } = useContext(Context)

    return (
        <Space>
            <Button onClick={create}>新增</Button>
        </Space>
    )
}
